import { render } from "./Approve.vue?vue&type=template&id=2c1f378a&scoped=true&ts=true"
import script from "./Approve.vue?vue&type=script&lang=ts"
export * from "./Approve.vue?vue&type=script&lang=ts"

import "./Approve.vue?vue&type=style&index=0&id=2c1f378a&lang=less&scoped=true"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1f378a"]])

export default __exports__